/**
 * A sprite as the game carries it (M75): its colors, and its rows, a symbol
 * a pixel, each naming a color by its place in `SPRITE_SYMBOLS`, '.' clear.
 * Built by `scripts/sprites.ts` into `sprites.ts`.
 */
export const SPRITE_SYMBOLS = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

export interface Sprite {
  width: number;
  height: number;
  palette: string[];
  rows: string[];
}

/**
 * A picture drawn whole (M75): the user's own at its own size, cleaned to flat
 * blocks of its colors, each row in runs, a symbol (or '.' for clear) and how
 * many, the count left out for one. Built by `scripts/sprites.ts` into
 * `sprites.ts`.
 */
export interface Picture {
  width: number;
  height: number;
  palette: string[];
  rows: string[];
}
